import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/core/components/ui/card";
import MapPin from "@/assets/icons/map-pin.svg?react";
import { useTranslation } from "react-i18next";
import { ReportViewerOverviewCardProps } from "../types";

export function ReportViewerOverviewCard({
  reportData,
}: ReportViewerOverviewCardProps) {
  const [translate] = useTranslation(["insights"]);
  return (
    <Card className="border-secondary">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <span className="text-blue-600">📊</span>
          {translate("report-viewer-overview-card-title")}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-3 gap-8 text-center">
          <Metric
            value={reportData.general_view.spaces_used}
            label={translate("report-viewer-overview-card-spaces-used")}
            className="text-neutral-700"
          />
          <Metric
            value={reportData.general_view.cities_covered}
            label={translate("report-viewer-overview-card-cities-covered")}
            className="text-green-600"
          />
          <Metric
            value={reportData.general_view.states_covered}
            label={translate("report-viewer-overview-card-states-covered")}
            className="text-blue-500"
          />
        </div>

        <div className="mt-8">
          <h4 className="font-medium mb-4 flex items-center gap-2">
            <MapPin className="h-4 w-4 text-yellow-500" />{" "}
            {translate("report-viewer-overview-card-map-of-usage")}
          </h4>
          <div className="bg-secondary h-48 rounded-[8px] flex items-center justify-center border border-secondary-200">
            <div className="text-center">
              <div className="w-12 h-12 bg-primary-500 rounded-full mx-auto mb-2 flex items-center justify-center">
                <MapPin className="h-6 w-6 text-neutral-950" />
              </div>
              <p className="font-medium">
                {translate("report-viewer-overview-card-national-distribution")}
              </p>
              <p className="text-sm text-gray-600">
                {translate("report-viewer-overview-card-highest-concentration")}
                : {reportData.general_view.highest_concentration.join(" e ")}
              </p>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

function Metric({
  value,
  label,
  className,
}: {
  value: number | string;
  label: string;
  className?: string;
}) {
  return (
    <div>
      <div className={`text-3xl font-bold ${className}`}>{value}</div>
      <div className="text-sm text-gray-600">{label}</div>
    </div>
  );
}
